<template>
  <div id="app">
<section class="hero is-small is-primary">
  <div class="hero-body">

   <div class="title">
  <div class="columns">
  <div class="column">
    <img src="./assets/republic_indemnity_logo.png" class="b-component-header-brand-logo__img" />
  </div>
  <div class="column">
                <span class="b-component-header-text-title">
                        Policyholder Portal 
                </span>
  </div>
  <div class="column is-half">
            <span class="b-component-header-text-right">
                   <a href="/account-management" class="top-link">Login</a> | <a :href="GetPublicURL()" class="top-link">Public Site</a>
                </span>
  </div>
  </div>

    </div> 
  </div>
</section>
<br/><br/>    

    <router-view />

  <br/><br/><br/>
  <footer>
    <div class="content">
    <div class="columns">
    <div class="column is-four-fifths">
      <div class="wrapper-nav-list-home">
          <ul id="navlist">
      
                                <li>
                                   <a href="https://www.republicindemnity.com/legal-disclosure" target="_blank">Legal Disclosures</a>
                                </li>    
              <li class="copy"><span> ©2001- {{ GetCurrentYear }} Republic Indemnity Company of America.</span><span> All rights reserved.</span>
              </li>
          </ul></div>
      </div>
      <div class="column">
        <div class="wrapper-gai-logo">
            <a class="gai-logo" href="http://www.greatamericaninsurancegroup.com/Pages/default.aspx" target="_blank"></a>
        </div>
      </div>  
  </div>
    </div>
  </footer>



  </div>
</template>

<script>
export default {
  name: "app",      
  computed: {
    // a computed getter
    GetCurrentYear: function () {
      return new Date().getFullYear();
    }
  },
  methods: {
        GetPublicURL: function() {
          let getUrl = window.location;
          let origin = `${getUrl.origin}`;
          if (origin.includes("securedev")) {
            return "https://wwwdev.republicindemnity.com/";
          } else if (origin.includes("secureqac")) {
            return "https://wwwqac.republicindemnity.com/";
          } else {
            return "https://www.republicindemnity.com/";
          }
        }
      }
};
</script>

<style>
  .container-fluid {
    margin-right: auto;
    margin-left: auto;
    padding-left: 10px;
    padding-right: 10px;
    width: 100%;
  }
  .hero-body {
      padding-bottom: 0rem !important;
      padding-top: 0rem !important;
      padding-left: 0rem !important;
  }

  .b-component-header-brand-logo__img {
    max-height: 90px;
  }

  .b-component-header-brand-footer__img {
    max-height: 58.3px;
  }

  .b-component-header-text-title {
    float: left;
    font-size: 1.0rem !important;
    padding-top: 2.0rem;   
  }  

  .b-component-header-text-right {
    float: right;
    font-size: 1.0rem !important;
    padding-top: 2.0rem !important;   
  }  


footer {
    background-color: var(--color_white);
    bottom: 0;
    padding-left: 10px;
    padding-right: 30px;
    height: 100px;
    /* -moz-box-shadow: 0 -1px 6px 0px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: 0 -1px 6px 0px rgba(0, 0, 0, 0.1);
    -o-box-shadow: 0 -1px 6px 0px rgba(0, 0, 0, 0.1);
    -ms-box-shadow: 0 -1px 6px 0px rgba(0, 0, 0, 0.1); */
    box-shadow: 0 -1px 6px 0px rgba(0, 0, 0, 0.1);
    font-size: 12px !important;
}


.wrapper-copy .copy span {
    color: #A1A1A1;
    font-size: 12px;
    line-height: 18px;
}

.wrapper-copy .copy a {
    color: #A1A1A1;
    font-size: 12px;
}

.wrapper-nav-list-home {
    margin-top: 20px;
}

.wrapper-nav-list-home ul {
    padding-left: 0px;
}

.wrapper-nav-list-home ul li {
        border-right: 1px solid #B6B7B6;
        display: inline;
        padding-right: 0.5em;
    }

.wrapper-nav-list-home ul li:first-child {
    padding-left: 0em;
}

.wrapper-nav-list-home ul li:last-child {
    border: none;
}

.wrapper-nav-list-home ul#navlist li a {
    font-size: 12px;
    color: #0b3b60;
    text-transform: capitalize;
}

.wrapper-nav-list-home ul#navlist li a:hover {
    text-decoration: none;
    color: #fbc316;
}

.wrapper-nav-list-home ul li.copy {
    color: #A1A1A1;
    font-size: 12px;
}


@media (min--moz-device-pixel-ratio: 1.3), (-o-min-device-pixel-ratio: 2.6 / 2), (-webkit-min-device-pixel-ratio: 1.3), (min-device-pixel-ratio: 1.3), (min-resolution: 1.3dppx) {
    footer .wrapper-row .wrapper-gai-logo .gai-logo {
        /*sitefinity override*/
        background-image: url("./assets/GAIG-Logo-Footer.png");
    }
}

.wrapper-gai-logo .gai-logo {
    /*sitefinity override*/
    background-image: url("./assets/GAIG-Logo-Footer.png");
    height: 60px;
    width: 160px;
    background-position: right;
    background-repeat: no-repeat;
    background-size: 123px 40px;
    float: right;
    margin-right: 0%;
}
</style>
